import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import {
  CODE_COLUMN_WIDTH,
  COLUMN_GAP,
  FIELD_BOX_HEIGHT,
  FIELD_LABEL_HEIGHT,
  TOGGLE_COLUMN_WIDTH,
} from '../layout';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

/** Arrow · code column · name column. Without a name slot the field spans both columns. */
const FieldRow = styled.div`
  display: grid;
  grid-template-columns: ${TOGGLE_COLUMN_WIDTH} ${CODE_COLUMN_WIDTH} minmax(0, 1fr);
  column-gap: ${COLUMN_GAP};
  row-gap: 0.8rem;
  align-items: start;
  width: 100%;

  ${mediaMinWidth.sm(css`
    grid-template-columns: ${TOGGLE_COLUMN_WIDTH} minmax(0, 1fr);
  `)};
`;

const FieldContent = styled.div<{ $wide: boolean }>`
  min-width: 0;

  ${({ $wide }) =>
    $wide &&
    css`
      grid-column: 2 / -1;
    `};
`;

const NameContent = styled.div`
  min-width: 0;

  ${mediaMinWidth.sm(css`
    grid-column: 2;
  `)};
`;

const ToggleButton = styled.button<{ $onLabel?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${TOGGLE_COLUMN_WIDTH};
  height: ${({ $onLabel }) => ($onLabel ? FIELD_LABEL_HEIGHT : FIELD_BOX_HEIGHT)};
  margin-top: ${({ $onLabel }) => ($onLabel ? 0 : FIELD_LABEL_HEIGHT)};
  padding: 0;

  background-color: transparent;
  color: ${pickColor('black')};
  border: none;

  cursor: pointer;
  transition: background-color 150ms ease-in, color 150ms ease-in;

  &:hover {
    color: ${pickColor('red')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 2rem;
    height: 2rem;
  }
`;

const DetailInset = styled.div`
  margin-left: calc(${TOGGLE_COLUMN_WIDTH} + ${COLUMN_GAP});
`;

export { DetailInset, FieldContent, FieldRow, NameContent, ToggleButton, Wrapper };
